import { StoreUser } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData, C, D, Rnd, Text  } from "@/helpers/global";
import { UserToken } from "@/services/requests/user_token";
import { UserService } from "@/services/api/user";

const module = {
    namespaced: true,
    timer: {
        detail: new WaitTimer(StoreUser.state.detail, 600),
    },
    state: () => ({
        me: {},
        detail: null,
        token: {},
    }),
    mutations: {
        set(state, data) {
            if (state.me != data) {
                state.me = data;
            }
        },
        setDetail(state, data) {
            if (state.detail != data) {
                state.detail = data;
            }
        },
        setToken(state, data) {
            if (state?.token != data) {
                state.token = data;
            }
        },
    },
    actions: {
        set(ctx, data) {
            ctx.commit("set", data);
        },
        setDetail(ctx, data) {
            ctx.commit("setDetail", data);
            module.timer.detail.resetLastFetchTime();
        },
        load({ state, dispatch }, p) {
            if (!state.me || p.reset) {
                UserService.Me((data) => {
                    if (data) {
                        for (let key in state.me) {
                            if (!data.hasOwnProperty(key)) {
                                data[key] = state.me[key];
                            }
                        }
                        dispatch("set", data);
                        //dispatch("setCT", Rnd.Text(50));
                        p.callback(data);
                    }
                }, p.wait);
            }
            else {
                p.wait();
                p.callback(state.me);
            }
        },
        loadDetail({ state, dispatch }, p) {
            if (!state.detail || p.reset || module.timer.detail.isTimeExpired(module.timer.detail.timeOut)) {
                UserService.MeDetail((data) => {
                    if (data) {
                        dispatch("setDetail", data);
                        p.callback(data);
                    }
                }, p.wait);
            }
            else {
                p.wait();
                p.callback(state.detail);
            }
        },
        login(ctx, data) {
            ctx.commit("setToken", data?.token);
            ctx.dispatch("set", {
                userType: C.Int(data.userType),
                userName: data.userName,
                email: data.email,
                phoneNumber: data.phoneNumber,
                emailConfirmed: data.emailConfirmed,
                phoneNumberConfirmed: data.phoneNumberConfirmed,
                fullName: data.fullName,
                profile: data.profile,
                name: data.name,
                lastName: data.lastName,
                gender: data.gender,
                isBuyPackage: C.Bool(data.isBuyPackage),
                activePackageId: C.Int(data.activePackageId),
                loginProvider: C.Str(data.loginProvider),                
            });
        },
        logout(ctx, isAll) {
            if (isAll) {
                sessionStorage.clear();
                localStorage.clear();
            }
            ctx.commit("set", {});
            ctx.commit("setDetail", {});
            ctx.commit("setToken", null);
        },
    },
    getters: {
        get(state) {
            return state.me;
        },
        getDetail(state) {
            return state.detail;
        },
        getToken(state) {
            return new UserToken(state.token);
        },
    }
};
export default module;